export default __webpack_public_path__ + "static/media/japanday_logo.986351fc.png";